import {groupBy} from "lodash/collection";

export const delay = millis => new Promise(resolve => setTimeout(resolve, millis))

export const getVariantFromStatus = (status) => {
    switch (status) {
        case 'IN QUEUE':
            return 'primary';
        case 'IN PROGRESS':
            return 'warning';
        case 'COMPLETED':
            return 'positive';
        default:
            return 'secondary';
    }
}

export const createOrderItem = ([orderGroupId, orders]) => {
    const sourceLanguage = orders[0].source_language;
    const targetLanguages = Object.keys(groupBy(orders, 'target_language'));
    const contents = Object.keys(groupBy(orders, 'id_order'));

    return {
        id: orderGroupId.slice(0, 20),
        id_requests: orders.map(({ id }) => id),
        idOrderGroup: orderGroupId,
        orders: orders,
        status: getStatusFromRequests(orders),
        numberOfLanguages: targetLanguages.length,
        sourceLanguage,
        targetLanguages,
        orderDate: orders[0].order_date,
        dueDate: orders[0].delivery_date,
        serviceType: orders[0].service_type,
        contents,
    }
}

export const getStatusFromRequests = (orders) => {
    if (orders.some(({ status }) => status === 'upload' || status === 'wc raw' || status === 'ingested'  || status === 'bucketing')) {
        return 'IN QUEUE';
    } else if (orders.every(({ status }) => status === 'delivered')) {
        return 'COMPLETED';
    } else {
        return 'IN PROGRESS';
    }
}